import { useAppContext } from '@/AppContext'
import CrossPlatformDialog from '@/dialogs/components/CrossPlatformDialog'
import StateTriggersPage from './StateTriggersPage'

export default function StateTriggersDialogController() {
    const [appState, appDispatch] = useAppContext()

    if (appState.appState.showStateTriggersDialog) {
        return (
            <CrossPlatformDialog
                frameName="Dialog:StateTriggersPage"
                onDefaultClose={() => {
                    appDispatch({ type: 'update_app_state', value: { showStateTriggersDialog: false } })
                }}
            >
                <StateTriggersPage />
            </CrossPlatformDialog>
        )
    } else {
        return null
    }
}
